import styled from '@emotion/styled';

// Main container components
export const EditorContainer = styled.div`
    display: flex;
    padding: 2rem;
    width: 100%;
    height: calc(100vh - 100px);
`;

export const EditorSection = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    width: 100%;
    > * {
        width: 100%;
        max-width: 100%;
        box-sizing: border-box;
    }
`;

// Form components
export const TitleInput = styled.input`
    width: 100%;
    padding: 0.5rem;
    font-size: 1.5rem;
    border: 1px solid #ddd;
    border-radius: 4px;
    margin-bottom: 1rem;
`;

export const EditorWrapper = styled.div`
    flex: 1;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 1rem;
    background-color: white;
    overflow-y: auto;
    width: 100%;
    box-sizing: border-box;

    .DraftEditor-root {
        width: 100%;
    }
    .DraftEditor-editorContainer {
        width: 100%;
    }
`;

// Toolbar components
export const Toolbar = styled.div`
    display: flex;
    gap: 1rem;
    padding: 0.75rem;
    background: #f8f9fa;
    border: 1px solid #e9ecef;
    border-radius: 8px;
    margin-bottom: 1rem;
    width: 100%;
    justify-content: space-between;
    align-items: center;

    .button-group {
        display: flex;
        gap: 0.5rem;
    }

    .save-button {
        margin-left: auto;
    }
`;

export const ToolbarButton = styled.button`
    padding: 0.5rem;
    background: ${(props) => (props.variant === 'primary' ? '#007bff' : props.active ? '#e9ecef' : 'white')};
    color: ${(props) => (props.variant === 'primary' ? 'white' : '#495057')};
    border: 1px solid ${(props) => (props.variant === 'primary' ? '#0056b3' : '#dee2e6')};
    border-radius: 6px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.9rem;
    transition: all 0.2s ease;
    min-width: 36px;
    justify-content: center;

    &:hover {
        background: ${(props) => (props.variant === 'primary' ? '#0056b3' : props.active ? '#dee2e6' : '#f8f9fa')};
        border-color: ${(props) => (props.variant === 'primary' ? '#004085' : '#ced4da')};
    }

    svg {
        font-size: 1rem;
    }

    &.media-button {
        padding: 0.5rem 0.75rem;
    }
`;
